import { createRoute } from '@tanstack/react-router';
import { lazy } from 'react';
import { authenticatedRoute } from '../_authenticated';

const ContentListPage = lazy(() =>
  import('@/features/content/components/ContentListPage').then((m) => ({
    default: m.ContentListPage,
  })),
);

export const contentRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/content',
  component: ContentListPage,
});
